function check_if_in_view(): void {
  // Mise à jour de la classe 'scrolled'
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('scrolled', scrollTop > 60);

  const windowHeight = window.innerHeight;
  const windowTop = scrollTop;
  const windowBottom = windowTop + windowHeight;

  const elements = document.querySelectorAll('.animation-element, body > *');

  elements.forEach((el) => {
    const element = el as HTMLElement;
    const rect = element.getBoundingClientRect();
    const elementTop = rect.top + window.scrollY;
    const elementBottom = elementTop + element.offsetHeight;

    if (elementBottom >= windowTop && elementTop < windowBottom) {
      element.classList.add('in-view');

      // Chargement lazy des images
      element.querySelectorAll('img[data-src]').forEach((img) => {
        const imgEl = img as HTMLImageElement;
        imgEl.src = imgEl.getAttribute('data-src')!;
        imgEl.removeAttribute('data-src');
      });
    } else {
      element.classList.remove('in-view');
    }
  });
}

// Bind natif sur scroll, resize et load
['scroll', 'resize', 'load'].forEach(name => {
  window.addEventListener(name, check_if_in_view)
});
